import ClubDiscount from '../dto/ClubDiscount';
import Error from '../model/Error';
import axios from 'axios';

export default class ClubDiscountRepository {

    static findByClubId(clubId)
    {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/discounts`)
                .then(response => resolve(response.data.data.map(data => ClubDiscount.fromData(data))))
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
